import { render, staticRenderFns } from "./ModalInvitesCall.vue?vue&type=template&id=f8bff2e0&scoped=true"
import script from "./ModalInvitesCall.vue?vue&type=script&lang=js"
export * from "./ModalInvitesCall.vue?vue&type=script&lang=js"
import style0 from "./ModalInvitesCall.vue?vue&type=style&index=0&id=f8bff2e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8bff2e0",
  null
  
)

export default component.exports